import { FormConfig, Text } from '@lbcamden/lib-react';
import { z } from 'zod';

import { riskToResidentPremisesSchema, severitySchema } from '~/common/schemas/pcfra';

import { FieldHeading } from '../common.styled';
import { RiskMatrix } from './RiskMatrix';

export type RiskToResidentPremisesFormValues = z.infer<typeof riskToResidentPremisesSchema>;

export const riskToResidentPremisesFormConfig = (
  values: Partial<RiskToResidentPremisesFormValues>,
): FormConfig<RiskToResidentPremisesFormValues> => ({
  hideAllRequiredIndicators: true,
  fieldConfigs: {
    fireLikelihood: {
      label: (
        <>
          <FieldHeading>Likelihood</FieldHeading>
          <Text>
            Taking into account the nature of the resident, their level of support, and the
            preventative measures in place, the likelihood of a fire occurring is:
          </Text>
        </>
      ),
      radioOptions: severitySchema.options,
    },
    harmPotential: {
      readOnly: values.fireLikelihood === undefined,
      label: (
        <>
          <FieldHeading>Potential consequences</FieldHeading>
          <Text>
            Taking into account the nature of the resident, their level of support, and protective
            measures in place, the potential level of harm is:
          </Text>
        </>
      ),
      radioOptions: severitySchema.options,
    },
    currentRiskLevel: {
      readOnly: values.harmPotential === undefined,
      label: <FieldHeading>Current risk level</FieldHeading>,
      customRenderFn: () => (
        <RiskMatrix fireLikelihood={values.fireLikelihood} harmPotential={values.harmPotential} />
      ),
    },
  },
});
